import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Heading from "common/components/Heading";
import Text from "common/components/Text";

import { SectionHeader } from "../interior.style";
import SectionWrapper, {
  Container,
  TextWrapper,
} from "../AboutUsManagement/aboutUs.style";

const AboutUs = () => {
  const data = useStaticQuery(graphql`
    query {
      interiorJson {
        aboutDataAccessible {
          title
          title1
          text1
          title2
          text2
          title3
          text3
          title4
          text4
        }
      }
    }
  `);
  const {
    title,
    title1,
    text1,
    title2,
    text2,
    title3,
    text3,
    title4,
    text4,
  } = data.interiorJson.aboutDataAccessible;

  const setTitle = (title) => {
    return { __html: title };
  };

  return (
    <SectionWrapper id="aboutUsAccessible">
      <SectionHeader>
        <Heading as="h2" dangerouslySetInnerHTML={setTitle(title)} />
      </SectionHeader>
      <Container>
        <TextWrapper>
          <Text as="span" content="01" />
          <Heading as="h3" dangerouslySetInnerHTML={setTitle(title1)} />
          <Text content={text1} />
        </TextWrapper>
        <TextWrapper>
          <Text as="span" content="02" />
          <Heading as="h3" dangerouslySetInnerHTML={setTitle(title2)} />
          <Text content={text2} />
        </TextWrapper>
        <TextWrapper>
          <Text as="span" content="03" />
          <Heading as="h3" dangerouslySetInnerHTML={setTitle(title3)} />
          <Text content={text3} />
        </TextWrapper>
        <TextWrapper>
          <Text as="span" content="04" />
          <Heading as="h3" dangerouslySetInnerHTML={setTitle(title4)} />
          <Text content={text4} />
        </TextWrapper>
      </Container>
    </SectionWrapper>
  );
};

export default AboutUs;
